import BreakpointManager from '../breakpoint_manager';

let FieldBreakpointHook = {
  mounted() {
    // Get data-enable and data-disable attributes
    this.enableBreakpoint = this.el.dataset.enable;
    this.disableBreakpoint = this.el.dataset.disable;

    // Bind the updateField method to the current context
    this.updateField = this.updateField.bind(this);

    // Subscribe to breakpoint changes
    BreakpointManager.subscribe(this.updateField);

    // Set the initial state of the field
    this.updateField();
  },

  updated() {
    this.updateField();
  },

  destroyed() {
    // Unsubscribe from breakpoint changes when the hook is destroyed
    BreakpointManager.unsubscribe(this.updateField);
  },

  updateField() {
    let disabled;

    // Disabled if current breakpoint less than desired breakpoint
    if (this.enableBreakpoint) {
      disabled = BreakpointManager.lt(this.enableBreakpoint);
    }

    // Disabled if current breakpoint greather than or equal to desired breakpoint
    if (this.disableBreakpoint) {
      disabled = BreakpointManager.gte(this.disableBreakpoint);
    }

    // Enable or disable the field based on the computed value
    this.el.disabled = disabled;
  },
};

export default FieldBreakpointHook;
